export default __webpack_public_path__ + "static/media/circle-red.27251725.svg";